import { v4 as uuidv4 } from 'uuid';

import {
	type EntitlementStatusAndSubscriptionStatusAndTrial,
	type ExpandedEntitlementFromSearch,
	type OrderId,
	type SubscriptionStatusAndTrial,
} from '../types';

import { isDateInPast } from './time';

export { createEntitlementDto, createEntitlementDtoFromEntitlements } from './orderCreation';

export const getPendingCancellationDate = (
	entitlement: ExpandedEntitlementFromSearch,
): number | undefined => {
	if (
		entitlement.status === 'ACTIVE' &&
		entitlement.order?.item?.type === 'CANCELLATION_ORDER' &&
		entitlement.subscription?.status === 'ACTIVE' &&
		entitlement.subscription?.endTimestamp
	) {
		return entitlement.subscription.endTimestamp;
	}

	return undefined;
};

export const generateOrderEstimateId: () => OrderId = () => uuidv4();

const isActiveSubscriptionStatus = (status: SubscriptionStatusAndTrial['status']): boolean =>
	status === 'ACTIVE';

export const isEntitlementInTrial = (
	item: EntitlementStatusAndSubscriptionStatusAndTrial,
): boolean => {
	if (
		item.subscription &&
		isActiveSubscriptionStatus(item.subscription.status) &&
		item.subscription.trial?.endTimestamp
	) {
		return !isDateInPast(item.subscription.trial.endTimestamp);
	}

	return false;
};
